import { PropsWithChildren } from "react";

import { Group, replaceUnderscores, Styled } from "~/common/utils";
import { OrganizationInvitationStatus } from "../types/organization";

export const TEAM_MEMBER_ROLE = {
  PROVIDER: "provider",
  STAFF: "staff",
} as const;

export const ORGANIZATION_TYPE = {
  ONGOING_CARE: "ongoing_care",
  CONSULTATION: "consultation",
} as const;

export const ORGANIZATION_SEAT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const ORGANIZATION_INVITATION_STATUS = {
  PENDING: "pending",
  CANCELLED: "canceled",
  REDEEMED: "redeemed",
  EXPIRED: "expired",
} as const;

export const organizationTypeParams = [
  ORGANIZATION_TYPE.CONSULTATION,
  ORGANIZATION_TYPE.ONGOING_CARE,
] as const;

export const organizationSeatStatusParams = [
  ORGANIZATION_SEAT_STATUS.ACTIVE,
  ORGANIZATION_SEAT_STATUS.INACTIVE,
] as const;

export const organizationInvitationStatusParams = [
  ORGANIZATION_INVITATION_STATUS.PENDING,
  ORGANIZATION_INVITATION_STATUS.CANCELLED,
  ORGANIZATION_INVITATION_STATUS.REDEEMED,
  ORGANIZATION_INVITATION_STATUS.EXPIRED,
] as const;

export type OrganizationType = keyof typeof ORGANIZATION_TYPE;

export const organizationInvitationStatusToTagMap: Record<
  OrganizationInvitationStatus,
  PropsWithChildren<Styled>
> = {
  [ORGANIZATION_INVITATION_STATUS.PENDING]: {
    className: "bg-warning-complementary text-orange-900 capitalize",
    children: ORGANIZATION_INVITATION_STATUS.PENDING,
  },
  [ORGANIZATION_INVITATION_STATUS.CANCELLED]: {
    className:
      "bg-complementary-error-100 text-complementary-error-700 capitalize",
    children: ORGANIZATION_INVITATION_STATUS.CANCELLED,
  },
  [ORGANIZATION_INVITATION_STATUS.REDEEMED]: {
    className: "bg-success-200 text-success-950 capitalize",
    children: ORGANIZATION_INVITATION_STATUS.REDEEMED,
  },
  [ORGANIZATION_INVITATION_STATUS.EXPIRED]: {
    className: "bg-neutral-5 text-gray-70 capitalize",
    children: ORGANIZATION_INVITATION_STATUS.EXPIRED,
  },
};

export const organizationTypeOptions = [
  {
    value: ORGANIZATION_TYPE.ONGOING_CARE,
    label: replaceUnderscores(ORGANIZATION_TYPE.ONGOING_CARE),
  },
  {
    value: ORGANIZATION_TYPE.CONSULTATION,
    label: replaceUnderscores(ORGANIZATION_TYPE.CONSULTATION),
  },
];

export const teamMemberRoleOptions = [
  {
    value: TEAM_MEMBER_ROLE.PROVIDER,
    label: replaceUnderscores(TEAM_MEMBER_ROLE.PROVIDER),
  },
  {
    value: TEAM_MEMBER_ROLE.STAFF,
    label: replaceUnderscores(TEAM_MEMBER_ROLE.STAFF),
  },
];

export const organizationInvitationStatusOptions = [
  {
    value: ORGANIZATION_INVITATION_STATUS.PENDING,
    label: replaceUnderscores(ORGANIZATION_INVITATION_STATUS.PENDING),
  },
  {
    value: ORGANIZATION_INVITATION_STATUS.CANCELLED,
    label: replaceUnderscores(ORGANIZATION_INVITATION_STATUS.CANCELLED),
  },
  {
    value: ORGANIZATION_INVITATION_STATUS.REDEEMED,
    label: replaceUnderscores(ORGANIZATION_INVITATION_STATUS.REDEEMED),
  },
  {
    value: ORGANIZATION_INVITATION_STATUS.EXPIRED,
    label: replaceUnderscores(ORGANIZATION_INVITATION_STATUS.EXPIRED),
  },
];

export const defaultOrganizationsFilters = {
  types: [ORGANIZATION_TYPE.CONSULTATION, ORGANIZATION_TYPE.ONGOING_CARE],
};

export const organizationTypesGroup: Group[] = [
  {
    group: "Type",
    groupOptions: organizationTypeOptions,
  },
] as const;

export const organizationInvitationStatusGroup: Group[] = [
  {
    group: "Status",
    groupOptions: organizationInvitationStatusOptions,
  },
] as const;
